import { Box, Button, Stack, Typography } from "@mui/material";

import { signOut } from "aws-amplify/auth";

import LanguageIcon from "@mui/icons-material/Language";
import { useDispatch } from "react-redux";
import { logout, setSignInStep } from "@store/slices/sessionSlice";

interface FormularioCuentaBloqueadaProps {}

export const FormularioCuentaBloqueada = (props: FormularioCuentaBloqueadaProps) => {
    const dispatch = useDispatch();

    return (
        <Stack
            direction={"column"}
            sx={{
                my: 2,
                mx: 4,
                justifyContent: "flex-start",
                alignItems: "center"
            }}>
            <Typography
                variant="h2"
                sx={{
                    fontWeight: 700,
                    color: "#002652"
                }}>
                {"Lo sentimos"}
            </Typography>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column"
                }}>
                <Typography
                    variant="body1"
                    sx={{
                        mt: 3,
                        textAlign: "center",
                        color: "#002652"
                    }}>
                    Tu cuenta ha sido bloqueada ya que has llegado al máximo número de intentos para ingresar el código
                    de autenticación
                </Typography>
                <Typography
                    variant="body1"
                    sx={{
                        color: "main2",
                        fontWeight: 700,
                        my: 4
                    }}>
                    {localStorage.getItem("email") ?? ""}
                </Typography>
                <Typography
                    variant="body1"
                    sx={{
                        color: "main3",
                        mt: 3,
                        textAlign: "center"
                    }}>
                    Para desbloquear tu cuenta contacta a soporte:
                </Typography>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        my: 3
                    }}>
                    <LanguageIcon color="main3" />
                    <Typography variant="body1" sx={{
                        color: "main3",
                        textAlign: "center"
                    }}>
                        contacto@lendia.mx
                    </Typography>
                </Box>
            </Box>
            <Button
                variant="contained"
                onClick={async () => {
                    await signOut();
                    dispatch(logout());
                    dispatch(setSignInStep(""));
                }}
            >
                Regresar
            </Button>
        </Stack>
    );
};
